import intl from "react-intl-universal";
import React, {MouseEvent, useCallback} from "react";


import {EmptyPage} from "../../components/EmptyPage"
import {RocketLaunch} from "../../components/icons/RocketLaunchIcon";
import {UpgradePlanButton} from "../../elements/typesOfButtons/UpgradePlanButton";
import {LogoIcon} from "../../components/icons/LogoIcon";


import {screenSizeProvider} from "../../../stores/ScreenSizeProvider";


export const LayoutAfterFreeTrial = () => {
    const isMobile = screenSizeProvider.view !== 'desktop';
    const ContactUs = (
        `<a href="/pricing#Contact_us" target="_blank" class="LayoutAfterFreeTrial__helper__btn btn btn--md btn--soft btn--inline btn--clickable">${intl.get('layout-after-free-trial.empty-page.contact-us').d('Contact us')}</a>`
    )

    const btnContainerClick = useCallback((event: MouseEvent<HTMLElement>) => {
        /* @ts-ignore */
        if (event.target.tagName !== 'A') {
            return;
        }
    }, []);
    return (
        <div>
            <div className='LayoutAfterFreeTrial__logo'>
                <LogoIcon size={null}/>
            </div>
            <EmptyPage
                className={"LayoutAfterFreeTrial__EmptyPage"}
                helperText={!isMobile ? (
                    <span onClick={btnContainerClick}>
                        {intl.getHTML('layout-after-free-trial.empty-page.helper', {ContactUs}).d(`Got questions? {ContactUs} — we’re happy to help.`)}
                </span>
                ) : (
                    <span onClick={btnContainerClick}>
                        {intl.getHTML('layout-after-free-trial.empty-page.helper.mobile', {ContactUs}).d(`Got questions?<br/> {ContactUs} — we’re happy to help.`)}
                </span>)}
                button={<UpgradePlanButton contentType={"iconWithFullText"} fullWidth={isMobile}/>}
                title={intl.get('layout-after-free-trial.empty-page.title').d("Your Free Trial Has Expired")}
                Icon={RocketLaunch}
                text={intl.getHTML('layout-after-free-trial.empty-page.text').d(`Your 30-day free trial is now over.<br/>To continue using all features and access your data, please upgrade to a paid plan.`)}
            />
        </div>
    )
}
